import $ from 'jquery';
import BaseModule from '@core/modules/base-module/base-module';


const tableBlock = new BaseModule();
tableBlock.name = 'table-block';
tableBlock.init(that => {
  const $table = that.elements.find('table');
  if ($table.length > 0) {
    $table.wrap('<div class="table__wrapper"></div>');
  }
});
